export const environment = {
  production: true,
  bankIdGatewayUrl: 'https://api-samtycke-bankid-gw-prod.bildsamtycke.se/service',
  dataServiceUrl: 'https://api-samtycke-be-prod.bildsamtycke.se/api',
  domain: 'admin.bildsamtycke.se',
}